import Model from 'models/Model';
import LossCode from '../lossCode/Model.LossCode';

export default class ClaimTypeJobItemTemplate
  extends Model<Model.IClaimTypeJobItemTemplate>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IClaimTypeJobItemTemplate>
{
  id: number;
  version: number;
  correction: number;
  jobItemTypeCode: string;

  claimTypeId: number;
  lossCodes: LossCode[];

  constructor(
    data: Partial<Model.IClaimTypeJobItemTemplate> | Utils.FormData<Model.IClaimTypeJobItemTemplate>,
    language?: Locale.Languages
  ) {
    super(
      {
        lossCodes: [LossCode],
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.id.toString(),
    };
  }
}
